import { CampaignAnalyticsReport } from '@components/Dashboard/CampaignAnalytics/slice/schema';

export const topStatesDmasLocationsSlideVisible = (
  campaignAnalyticsReport: CampaignAnalyticsReport
): boolean =>
  [
    campaignAnalyticsReport.stateVisits,
    campaignAnalyticsReport.dmaVisits,
    campaignAnalyticsReport.brandLocationVisits,
  ].every(field => field.visible);

export const moreStatsSlideVisible = (
  campaignAnalyticsReport: CampaignAnalyticsReport
) =>
  [
    campaignAnalyticsReport.proximityToHome,
    campaignAnalyticsReport.visitsByHourOfDay,
    campaignAnalyticsReport.visitsByDayOfWeek,
    campaignAnalyticsReport.timeToFirstVisitByDay,
  ].some(field => field.visible);

export const visitorProfileSlideVisible = (
  campaignAnalyticsReport: CampaignAnalyticsReport
) =>
  [
    campaignAnalyticsReport.demographicProfile,
    campaignAnalyticsReport.stateVisits,
    campaignAnalyticsReport.dmaVisits,
    campaignAnalyticsReport.brandLocationVisits,
    campaignAnalyticsReport.proximityToHome,
    campaignAnalyticsReport.timeToFirstVisitByDay,
    campaignAnalyticsReport.visitsByHourOfDay,
    campaignAnalyticsReport.visitsByDayOfWeek,
  ].some(field => field.visible);
